import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';

// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  const [openGroup, setOpenGroup] = useState(null);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const groupDefaultUrls = {
    support: '/cadastros/anamnese'
  };

  const activeGroupId = useMemo(() => {
    const activeGroup = menuItem.items.find((group) =>
      group.children?.some((child) => {
        const itemPath = child?.link || child?.url;
        if (!itemPath) return false;

        return !!matchPath({ path: itemPath, end: itemPath === '/' }, pathname);
      })
    );

    return activeGroup?.id ?? null;
  }, [pathname]);

  useEffect(() => {
    if (activeGroupId) {
      setOpenGroup(activeGroupId);
    }
  }, [activeGroupId]);

  const handleGroupClick = (item) => {
    const isOpening = openGroup !== item.id;

    if (!activeGroupId || activeGroupId !== item.id) {
      setOpenGroup(isOpening ? item.id : null);
    }

    if (isOpening && item.children?.[0]?.url) {
      const url = groupDefaultUrls[item.id] || item.children[0].url;
      navigate(url);
    }
  };

  const navGroups = menuItem.items.map((item) => {
    switch (item.type) {
      case 'group':
        return (
          <NavGroup
            key={item.id}
            item={item}
            open={activeGroupId === item.id || openGroup === item.id}
            onClick={() => handleGroupClick(item)}
          />
        );
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
